var langselectortoggle = document.getElementById('langSelectorOpener');
var langselectorpanel = document.getElementById('langSelectorPanel');
var langselectorpanelbg = document.getElementById('langSelectorPanelBg');
var langselectorclose = document.getElementById('langSelectorCloseBtn');
var langselectortoggleInDrawer = document.getElementById('langSelectorOpenerDrawer');
var langselectortoggleInHeader = document.getElementById('langSelectorOpenerHeader');
var langSelectorOpeners = [langselectortoggle, langselectortoggleInDrawer, langselectortoggleInHeader].filter(Boolean);
var lastLangSelectorOpener = null;

function closeLangSelector(restoreFocus = true) {
  if (!langselectorpanel) return;
  langselectorpanel.classList.remove('open');
  langselectorpanelbg?.classList.remove('open');
  langselectorpanel.setAttribute('aria-hidden', 'true');
  if (lastLangSelectorOpener) lastLangSelectorOpener.setAttribute('aria-expanded', 'false');
  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus(restoreFocus ? lastLangSelectorOpener : null);
  } else if (restoreFocus) {
    lastLangSelectorOpener?.focus();
  }
  lastLangSelectorOpener = null;
}

function openLangSelector(event) {
  if (!langselectorpanel) return;
  event.preventDefault();
  lastLangSelectorOpener = event.currentTarget;
  langSelectorOpeners.forEach(function(opener) {
    opener.setAttribute('aria-expanded', opener === lastLangSelectorOpener ? 'true' : 'false');
  });
  langselectorpanel.classList.add('open');
  langselectorpanelbg?.classList.add('open');
  langselectorpanel.setAttribute('aria-hidden', 'false');
  if (typeof trapFocus === 'function') {
    trapFocus(langselectorpanel, langselectorclose || langselectorpanel);
  } else {
    langselectorclose?.focus();
  }
}

langSelectorOpeners.forEach(function(opener) {
  opener.addEventListener('click', openLangSelector);
});

langselectorclose?.addEventListener('click', function(event) {
  event.preventDefault();
  closeLangSelector();
});

langselectorpanelbg?.addEventListener('click', function() {
  closeLangSelector();
});

langselectorpanel?.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    event.preventDefault();
    closeLangSelector();
  }
});
